import { useMutation } from '@apollo/client'
import { t } from 'i18next'
import React, { useState } from 'react'
import { MdClose } from 'react-icons/md'
import { STORE, SelectSubscription } from '../../../graphql'
import useStore from '../../../store/useStore'
import { SubscriptionProps } from '../../../types'

interface Props {
  setAddSubscribePopup: React.Dispatch<React.SetStateAction<boolean>>
  selectedPlan: SubscriptionProps | undefined
  setSuccessMsg: React.Dispatch<React.SetStateAction<string>>,
  setSuccess: React.Dispatch<React.SetStateAction<boolean>>,
}

const AddSubscribePopup = ({ setAddSubscribePopup, selectedPlan, setSuccessMsg, setSuccess }: Props) => {
  const storeData = useStore((state: any) => state.userData.store);

  const [first, setFirst] = useState("");

  // Create
  const [selectSubscription, { loading }] = useMutation(SelectSubscription, {
    onError: (error) => {
      console.error(error);
    },
    onCompleted: () => {
      setSuccessMsg(t('subscribedSucc'))
      setAddSubscribePopup(false)
      setSuccess(true)
    },
    refetchQueries: [{
      query: STORE,
      variables: { storeId: storeData.id }
    }]
  });

  const save = async () => {
    var currentDate = new Date();
    var nextMonthDate = new Date(currentDate);
    var unixTimestamp = Math.floor(currentDate.getTime() / 1000);

    // Add a month to the current date
    nextMonthDate.setMonth(currentDate.getMonth() + 1);

    // Get the Unix timestamp (in seconds) for the updated date
    var unixTimestamp_month = Math.floor(nextMonthDate.getTime() / 1000);

    selectSubscription({
      variables: {
        content: {
          endDate: unixTimestamp_month,
          idStore: storeData.id,
          idSubscription: selectedPlan?.id,
          price: selectedPlan?.price,
          startDate: unixTimestamp
        }
      }
    })
  }

  return (
    <div className='fixed inset-0 z-50 flex items-center justify-center w-full min-h-screen py-6 bg-gray-900/10 backdrop-blur-md'>
      {
        loading &&
        <div className='absolute top-0 left-0 z-30 flex items-center justify-center w-full h-full py-10 bg-white/70'>
          <svg aria-hidden="true" className="w-8 h-8 mr-2 text-gray-200 animate-spin fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
            <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
          </svg>
        </div>
      }

      <div className='w-5/6 p-2 overflow-y-auto bg-white border md:w-4/6 h-[80vh]'>
        <div className='flex justify-end py-2 text-gray-600'>
          <div onClick={() => setAddSubscribePopup(false)} className='cursor-pointer'>
            <MdClose size={20} />
          </div>
        </div>

        <div className='flex justify-center items-center w-full h-[70vh]'>
          <div className="flex flex-col items-center justify-center w-full h-full">

            <div className='w-full'>
              <label htmlFor="payment" className="block mb-2 text-sm font-medium text-gray-900">{t('paying')}</label>
              <input type="text" id="payment" value={first} onChange={(e) => setFirst(e.target.value)} className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary focus:border-primary outline-none block w-full p-2.5" placeholder={t('paying')} required />
            </div>

            <div className='flex justify-end w-full pt-5'>
              <button onClick={save} className='inline-flex items-center justify-center w-full px-4 py-2.5 overflow-hidden text-sm text-white transition-colors duration-300 bg-primary rounded-lg shadow sm:w-auto my-2 md:my-0 hover:bg-primaryHover'>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M20 2H8c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zM8 16V4h12l.002 12H8z"></path>
                  <path d="M4 8H2v12c0 1.103.897 2 2 2h12v-2H4V8zm11-2h-2v3h-3v2h3v3h2v-3h3V9h-3z"></path>
                </svg>

                <span className="mx-2">
                  {t('save')}
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AddSubscribePopup